<script setup lang="ts">
import OrderedList from "@/views/playground/planner/order-management/ordered-list/OrderedList.vue";
</script>

<template>
  <ordered-list></ordered-list>
</template>

<style scoped></style>
